
import { ChangeDetectorRef, Component, EventEmitter, OnInit, Pipe, PipeTransform } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { Config } from 'src/app/app-constant';
import { ToastController } from '@ionic/angular';
import { DatePipe } from '@angular/common';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import { forkJoin, iif } from 'rxjs';
import { DataRefreshService } from 'src/app/services/dataRefreshService.service';
import { calculateFiscalYear, formatYearRanges} from 'src/app/shared/commen-function-file';

@Component({
  selector: 'app-lnd-setup',
  templateUrl: './lnd-setup.component.html',
  styleUrls: ['./lnd-setup.component.scss'],
})
export class LndSetupComponent  implements OnInit {
  
  buttonColorName: any;
  pmsYears: any = [];
  ratingScale: boolean = false;
  selectedBucket: string = ''; // Default selected bucket
  subModuleButtonColor: any | null;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserEmpCode: any | null;
  loggedInUserId: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserRole: any;
  loggedInUserRoles: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: any;
  fromYear: any;
  selectedYear: any;
  toYear: any;
  selectedYearForCompetency: any = null;
  getFeedbackEmployee: any;
  getJobLearningForManager: any;
  getJobBehaviorForManager: any;
  getJobLearning: any;
  getJobBehavior: any;

  constructor(private datePipe: DatePipe, public sharedService: SharedService,
    private loader: LoaderService, private encryptionService: EncryptionService,
    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog,
    private activatedroute: ActivatedRoute, private toastr: ToastrService,
    private toastController: ToastController,
    private cdRef: ChangeDetectorRef,
    private PdfDownload: PdfDownloadService, private dataRefreshService: DataRefreshService) { 
   
    }
    ngOnInit() {
    
      this.buttonColorName = sessionStorage.getItem('buttonColorName');
      this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
      this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
  
  
      this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
      this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
      if (this.loggedInCompanyFiscalyear) {
        this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
      }
      this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
      this.loggedInUserId = sessionStorage.getItem('loggedInUserName');
      this.loggedInUserId = sessionStorage.getItem('loggedInUserRole');
      this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
      if (this.loggedInUserRole) {
        this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
      }
      this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
      this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
      if (this.loggedInUserRoles.length == 1) {
        for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
          if (this.loggedInUserRoles[i].displayName == "Employee") {
            this.loggedInUserRoleIsEmployee = true
          }
        }
      }
      this. getpmsyearlist();
    }
  

  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
      
      this.setSelectedYear(yearValue);

    });
  }
    
    setSelectedYear(yearValue: string): void {
      const selectedYearObj = this.pmsYears.find((ele:any) => ele.year === yearValue);
      if (selectedYearObj) {
            this.selectedYearForCompetency = selectedYearObj?.year;
           
            let test = selectedYearObj?.year.split('-');
            this.fromYear = test[0];
            this.toYear = test[1];
            this.defaultCallFunctionsList();
            [this.fromYear, this.toYear] = selectedYearObj.year.split('-');
      }
    }
  

    defaultCallFunctionsList() {
      this.getRating();
      this.getEmployeeFeedback();
      this.getJobLearningFeedback();
      this.getJobBehaviorFeedback();
      this.getCapKpi();
      this.getCapCompetency();
    }

    selectYearSetup(year: any) {
      this.selectedYearForCompetency = year;
      this.selectedYear = year;
      this.defaultCallFunctionsList();
    }
 

  addQuestionForEmployee = [
    { questionType: 'Rating ' },
    { questionType: 'Open Ended '  }
  ];
  addQuestionForManager=[
    { questionType: 'Rating ', question: 'abc ' },
    { questionType: 'Open Ended ', question: 'zyx ' }
  ]

  addQuestionForManagerJobLearning=[
    { questionType: 'Rating ' },
    { questionType: 'Open Ended ' }
  ]

 

  onClickback() {
    this.router.navigate(['/home/hrportal/lnd']);

  }



  removeInputs() {
      this.ratingScale = false;
      this.rating = '';
      this.definition = '';
  }

 

  toggleInputs(bucketType: string) {
    this.selectedBucket = bucketType;
  
    if (this.selectedBucket === 'addRatingScale') {
      if (this.ratingScale) {
        this.saveRatingScale();
      } 
      this.ratingScale = !this.ratingScale;
  
    }  
  }



  openDialog(message: string, buttonText: string = 'OK', buttonColor: string = 'red', showSuccessIcon: boolean = false, showSuccessMessage: boolean = false, showCloseIcon: boolean = false) {
    return this.dialog.open(ConfirmationPopupComponent, {
      disableClose: false,
      height: '25%',
      width: '30%',
      data: {
        msg: message,
        btn2: buttonText,
        btn2BgColor: buttonColor,
        showSuccessIcon: showSuccessIcon,
        showSuccessMessage: showSuccessMessage,
        showCloseIcon: showCloseIcon
      }
    });
  }


// ==========================================================KPI Cap Value=============================================

kpiCapValue:any;
editFlagForKpi: boolean = false
kpiCapId: any;

preventNegative(event: KeyboardEvent) {
  if (event.key === '-' || event.key === 'e' || event.key === '.') {
    event.preventDefault();
  }
}


saveForKpi() {
    if (this.kpiCapValue === null || this.kpiCapValue === undefined || this.kpiCapValue === '') {
      this.toastr.error('Please enter a value before saving.', 'Error');
      return;
    }
  let payload = {
    "id": this.kpiId || null,
     "kpiCapValue": this.kpiCapValue,
    "companyId": this.loggedInUserCompanyID,
    "year": this.selectedYearForCompetency,
    "fiscalYear": this.loggedInCompanyFiscalyear,
  }
  this.httpService.callPostService(`${this.config.saveKPI}`, payload)
    .subscribe((data: any) => {

      if (data) {
        this.toastr.success(data.message, 'Success');
        // Success popup
          this.getCapKpi();
        // Handle the result of the dialog
         this.editFlagForKpi = false;
      }
    },
      (error: any) => {

         this.toastr.error(error.error.error || 'An error occurred while processing your request. Please try again.', 'Error');
      }
    )

}


kpiId:any;
getCapKpi(){
  let companyId = this.loggedInUserCompanyID;
      let year = this.selectedYear ? this.selectedYear : this.selectedYearForCompetency;
      let fiscal_year = this.loggedInCompanyFiscalyear;
      this.httpService.callGetService(this.config.getKpiCap + fiscal_year+"/"+year+"/"+companyId).subscribe((result: any) => {
        
            this.kpiCapValue = result?.data[0]?.kpiCapValue;
            this.kpiId = result?.data[0]?.id
        });
          
}




onClickEditForKpi() {
  this.editFlagForKpi = true
}

onClickCloseForKpi() {
  this.getCapKpi();
  this.editFlagForKpi = false;
}



// =========================================== Cap Value Competency Actual =============================================

competencyCapValue:any;
editFlagForCapActual: boolean = false
capActaulId: any;


saveForCapActual() {

   if (this.competencyCapValue === null || this.competencyCapValue === undefined || this.competencyCapValue === '') {
      this.toastr.error('Please enter a value before saving.', 'Error');
      return;
    }

  let payload = {
    "id": this.competecyId || null,
    "competencyCapValue": this.competencyCapValue,
    "companyId": this.loggedInUserCompanyID,
    "year": this.selectedYearForCompetency,
    "fiscalYear": this.loggedInCompanyFiscalyear,
  }
  this.httpService.callPostService(`${this.config.saveCompetency}`, payload)
    .subscribe((data: any) => {
      if (data) {
          this.toastr.success(data.message, 'Success');
        this.getCapCompetency();
        this.editFlagForCapActual = false;
      }
    },
      (error: any) => {
          this.toastr.error(error.error.error || 'An error occurred while processing your request. Please try again.', 'Error');
      }
    )


}

competecyId:any

getCapCompetency(){
  let companyId = this.loggedInUserCompanyID;
      let year = this.selectedYear ? this.selectedYear : this.selectedYearForCompetency;
      let fiscal_year = this.loggedInCompanyFiscalyear;
      this.httpService.callGetService(this.config.getCapCompetency + fiscal_year+"/"+year+"/"+companyId).subscribe((result: any) => {
            this.competencyCapValue = result?.data[0]?.competencyCapValue;
            this.competecyId = result?.data[0]?.id;
        });
}


onClickEditForCapActual() {
  this.editFlagForCapActual = true
}

onClickCloseForCapActual() {
  this.getCapCompetency();
  this.editFlagForCapActual = false;
}



// ===========================================Add Rating Scale=============================================

  
  definition: string = '';
  ratingId:any;
  rating: any;

  saveRatingScale() {
    if (this.rating === null || this.rating === undefined || this.rating === '') {
      this.toastr.error('Please enter a value before saving.', 'Validation Error');
      return;
    }
    const payload = {
      ratingId: this.ratingId, 
      rating: this.rating,
      definition: this.definition,
      companyId: this.loggedInUserCompanyID,
      year: this.selectedYear || this.selectedYearForCompetency,
       fiscalYear:this.loggedInCompanyFiscalyear
       
    };
    this.httpService.callPostService(`${this.config.saveRating}`, payload).subscribe({
        next: async (result: any) => {
            this.getRating();
            this.rating = '';
            this.definition = '';
            this.ratingScale = false;
            this.toastr.success('Training Effect Rating added successfully', 'Success');
          
        },
        error: async (err: any) => {
             this.toastr.error(err.error.message, 'Error');
            
        }
    });
}
 

getratingScale:any=[]
getRating(){
  let companyId = this.loggedInUserCompanyID;
      let year = this.selectedYear ? this.selectedYear : this.selectedYearForCompetency;
      let fiscal_year = this.loggedInCompanyFiscalyear;
      this.httpService.callGetService(this.config.getRatings + fiscal_year+"/"+year+"/"+companyId).subscribe((result: any) => {
         this.getratingScale = result.data;
       console.log("getRatings====",  this.getratingScale);
       
        })     
}







deleteRatings(ratingType: any) {
  const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
    disableClose: true,
    height: '25%',
    width: '30%',
    data: {
      msg: 'Do you really want to delete Rating Scale?',
      btn1: 'Cancel',
      btn2: 'Delete',
      btn2BgColor: this.buttonColorName,
      showSuccessIcon: false,
      showSuccessMessage: false,
      showCloseIcon: false,
    },
  });

  dialogRef.afterClosed().subscribe((result) => {
    if (result) {

      if (this.selectedYearForCompetency && this.loggedInUserCompanyID) {
        this.httpService.callDeleteService(
          `${this.config.deleteAllRating}${this.selectedYearForCompetency}/${this.loggedInUserCompanyID}`
        ).subscribe(
          () => {
            this.toastr.success('Deleted Successfully', 'Success');
            this.getRating();
           
          },
          (error: any) => {
            console.error('Deletion failed:', error);

            
            this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: 'Failed to delete Rating Scale. Please try again.',
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false,
              },
            });
          }
        );
      } else {
        console.error('Missing selectedYearForCompetency or loggedInUserCompanyID');
        this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: 'Cannot delete. Year or Company ID is missing.',
            btn2: 'OK',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: false,
            showSuccessMessage: false,
            showCloseIcon: false,
          },
        });
      }
    }
  });
}


// ===========================================   Training Reaction Feedback-Employee ===================================================================

employeeFeedbackList: any[] = [];
employeeQuestionType: string = '';
employeeQuestion: string = '';
employeeId: number | null = null;
editedScoreId: number | null = null;

saveEmployeeFeedback(item?: any) {
  
  const isUpdate = !!item?.id;
  if (item.questionType === null || item.questionType === undefined || item.questionType === '') {
    this.toastr.error('Please select question type.', 'Error');
    return;
  }
  if (item.question === null || item.question === undefined || item.question === '') {
    this.toastr.error('Please enter a question.', 'Error');
    return;
  }

  const payload = {
    id: isUpdate ? item.id : null,
    questionType: item?.questionType || this.employeeQuestionType,
    question: item?.question || this.employeeQuestion,
    companyId: this.loggedInUserCompanyID,
    year: this.selectedYear || this.selectedYearForCompetency,
    fiscalYear: this.loggedInCompanyFiscalyear
  };

  this.httpService.callPostService(`${this.config.saveEmployeeFeedback}`, payload).subscribe({
    next: (result: any) => {
        this.toastr.success(
        `Training Reaction Feedback Form ${isUpdate ? 'updated' : 'added'} successfully`,
        'Success'
      );
     
      this.getEmployeeFeedback();
      this.editedScoreId = null;
    },
    error: (err: any) => {
      this.toastr.error(err.error.message, 'Error');
    }
  });
}





getEmployeeFeedback() {
  const year = this.selectedYear || this.selectedYearForCompetency;
  const fiscalYear = this.loggedInCompanyFiscalyear;
  this.httpService.callGetService(`${this.config.getEmployeeFeedback}${fiscalYear}/${year}/${this.loggedInUserCompanyID}`)
    .subscribe((result: any) => {
      this.employeeFeedbackList = result.data || [];
    });
}

editRow(index: number) {
  this.editedScoreId = index;
}


cancelEdit() {
  this.getEmployeeFeedback();
  this.editedScoreId = null;
}


addRow() {
  this.employeeFeedbackList.push({
    id: null,
    questionType: '',
    question: '',
    isNew: true
  });
  this.editedScoreId = this.employeeFeedbackList.length - 1;
}


deleteFeedback(item: any) {
  const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
    disableClose: true,
    height: '25%',
    width: '30%',
    data: {
      msg: 'Do you really want to delete Rating Scale?',
      btn1: 'Cancel',
      btn2: 'Delete',
      btn2BgColor: this.buttonColorName,
    },
  });

  dialogRef.afterClosed().subscribe((result) => {
    if (result) {
      this.httpService.callDeleteService(`${this.config.deleteEmployeeFeedback}${item.id}`)
        .subscribe(() => {
          this.getEmployeeFeedback();
          this.toastr.success('Deleted successfully', 'Success');
        });
    }
  });
}




// =================================Training Job learning Feedback Form - Manager===========================
learningId: any;
learningQuestionType: string = '';
learningQuestion: string = '';
editedScoreIdForlearning: number | null = null;
employeeFeedbackListForLearning: any[] = [];


saveJobLearningFeedback(item?:any){
  const isUpdate = !!item?.id;
  if (item.questionType === null || item.questionType === undefined || item.questionType === '') {
    this.toastr.error('Please select question type.', 'Error');
    return;
  }
  if (item.question === null || item.question === undefined || item.question === '') {
    this.toastr.error('Please enter a question.', 'Error');
    return;
  }
  const payload = {
    id: isUpdate ? item.id : this.learningId,
    questionType: item?.questionType || this.learningQuestionType,
    question: item?.question || this.learningQuestion,
    companyId: this.loggedInUserCompanyID,
    year: this.selectedYear || this.selectedYearForCompetency,
    fiscalYear:this.loggedInCompanyFiscalyear
     
  };
  this.httpService.callPostService(`${this.config.saveJobLearningForManager}`, payload).subscribe({
    next: (result: any) => {
      this.toastr.success(
        `Training Job Learning Feedback Form ${isUpdate ? 'updated' : 'added'} successfully`,
        'Success'
      );
    
      this.getJobLearningFeedback();
      this.editedScoreIdForlearning = null;
    },
    error: (err: any) => {
      this.toastr.error(err.error.message, 'Error');
    }
  });
}




getJobLearningFeedback() {
  const year = this.selectedYear || this.selectedYearForCompetency;
  const fiscalYear = this.loggedInCompanyFiscalyear;

  this.httpService.callGetService(`${this.config.getJobLearningForManager}${fiscalYear}/${year}/${this.loggedInUserCompanyID}`)
    .subscribe((result: any) => {
      this.employeeFeedbackListForLearning = result.data || [];
      console.log("Job Learning Feedback:", this.getJobLearning);
    });
}



editRowfForLearning(index: number) {
  this.editedScoreIdForlearning = index;
}


cancelEditForLearning() {
  this.getJobLearningFeedback();
  this.editedScoreIdForlearning = null;
}


addRowForLearning() {
  this.employeeFeedbackListForLearning.push({
    id: null,
    questionType: '',
    question: '',
    isNew: true
  });
  this.editedScoreIdForlearning = this.employeeFeedbackListForLearning.length - 1;
}

deleteLearningFeedback(item: any) {
  const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
    disableClose: true,
    height: '25%',
    width: '30%',
    data: {
      msg: 'Do you really want to delete Job Learning Feedback Form?',
      btn1: 'Cancel',
      btn2: 'Delete',
      btn2BgColor: this.buttonColorName,
    },
  });

  dialogRef.afterClosed().subscribe((result) => {
    if (result) {
      this.httpService.callDeleteService(`${this.config.deleteLearningFeedback}${item.id}`)
        .subscribe(() => {
          this.getJobLearningFeedback();
          this.toastr.success('Deleted successfully', 'Success');
        });
    }
  });
}


// =================================Training Job Behavior Feedback Form - Manager===========================

behaviourId: any;
behaviourQuestionType: string = '';
behaviourQuestion: string = '';
editedScoreIdForBehaviour: number | null = null;
employeeFeedbackListForBehaviour: any[] = [];


saveJobBehaviorFeedback(item?:any){
  const isUpdate = !!item?.id;
   if (item.questionType === null || item.questionType === undefined || item.questionType === '') {
    this.toastr.error('Please select question type.', 'Error');
    return;
  }
  if (item.question === null || item.question === undefined || item.question === '') {
    this.toastr.error('Please enter a question.', 'Error');
    return;
  }
  const payload = {
    id: isUpdate ? item.id : this.behaviourId,
    questionType:item?.questionType || this.behaviourQuestionType,
    question: item?.question || this.behaviourQuestion,
    companyId: this.loggedInUserCompanyID,
    year: this.selectedYear || this.selectedYearForCompetency,
    fiscalYear:this.loggedInCompanyFiscalyear
     
  };
  this.httpService.callPostService(`${this.config.saveJobBehaviorForManager}`, payload).subscribe({
    next: (result: any) => {
      this.toastr.success(
        `Training Job Behaviour Feedback Form ${isUpdate ? 'updated' : 'added'} successfully`,
        'Success'
      );
         
      this.getJobBehaviorFeedback();
      this.editedScoreIdForBehaviour = null;
    },
    error: (err: any) => {
      this.toastr.error(err.error.message, 'Error');
    }
  });
}


getJobBehaviorFeedback() {
  const companyId = this.loggedInUserCompanyID;
  const year = this.selectedYear || this.selectedYearForCompetency;
  const fiscalYear = this.loggedInCompanyFiscalyear;

  this.httpService.callGetService(`${this.config.getJobBehaviorForManager}${fiscalYear}/${year}/${companyId}`)
    .subscribe((result: any) => {
      this.employeeFeedbackListForBehaviour = result.data || [];
      console.log("Job Behaviour Feedback:", this.employeeFeedbackListForBehaviour);
    });
}




editRowfForBehaviour(index: number) {
  this.editedScoreIdForBehaviour = index;
}


cancelEditForBehaviour() {
  this.getJobBehaviorFeedback();
  this.editedScoreIdForBehaviour = null;
}


addRowForBehaviour() {
  this.employeeFeedbackListForBehaviour.push({
    id: null,
    questionType: '',
    question: '',
    isNew: true
  });
  this.editedScoreIdForBehaviour = this.employeeFeedbackListForBehaviour.length - 1;
}

deleteBehaviorFeedback(item: any) {
  const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
    disableClose: true,
    height: '25%',
    width: '30%',
    data: {
      msg: 'Do you really want to delete Job Learning Feedback Form?',
      btn1: 'Cancel',
      btn2: 'Delete',
      btn2BgColor: this.buttonColorName,
    },
  });

  dialogRef.afterClosed().subscribe((result) => {
    if (result) {
      this.httpService.callDeleteService(`${this.config.deleteBehaviourFeedback}${item.id}`)
        .subscribe(() => {
          this.getJobBehaviorFeedback();
          this.toastr.success('Deleted successfully', 'Success');
        });
    }
  });
}
 


}
